import apiClient from './client';
import { BusinessProfile } from '../types';

export const businessProfilesApi = {
  getAll: async (params?: { active?: boolean }) => {
    const response = await apiClient.get<BusinessProfile[]>('/business-profiles', { params });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<BusinessProfile>(`/business-profiles/${id}`);
    return response.data;
  },

  getBySlug: async (slug: string) => {
    const response = await apiClient.get<BusinessProfile>(`/business-profiles/slug/${slug}`);
    return response.data;
  },

  getByIndustry: async (industry: string) => {
    const response = await apiClient.get<BusinessProfile[]>(`/business-profiles/industry/${industry}`);
    return response.data;
  },
};
